import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import {
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../components/MaterialInput";
import MaterialBox from "../../../components/MaterialBox";
import MaterialButton from "../../../components/MaterialButton";
import { useLocation, useNavigate } from "react-router-dom";
import { BsFillPersonBadgeFill } from "react-icons/bs";
import { useAuth } from "../../../context/AuthContext/AuthContextProvider";
import request from "graphql-request";
import BASEURL from "../../Utils/Baseurl";
import { AddCategoryMutation } from "../../../lib/graphQL/graphMutation";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { getProductcategory } from "../../../lib/graphQL/graphQuery";
import {
  delteProductcategoryService,
  updateProductcategoryService,
} from "../../../lib/appUtliz/ProductcategoryService";
import { useLoading } from "../../../context/LodingContext";
import { useSuccess } from "../../../context/SucccessContext";
import { useError } from "../../../context/ErrorContext";

export default function AddCategory() {

  const navigate = useNavigate();
  const params = useLocation();
  const id = params.search.slice(1);
  const { currentUser } = useAuth();
  const [selectedData, setSelectedData] = useState([]);
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
    done: "",
    back: "",
  });

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus , errormessage, setErrormessage } = useError();
  const [pendingLoading, setPendingLoading] = useState(false);
  const [categoryData, setCategoryData] = useState({
    // Category Details
    categoryName: "",

    // Category Type Status
    categoryNameStatus: "unchecked",
  });

    //UseEffect for Page Toggle
  useEffect(() => {
    setTogglePage({
      ...togglePage,
      view: params?.search !== "" ? true : false,
    });
  }, []);

    //UseEffect to fetch by Id
  useEffect(() => {
    if (id) {
      fetchUpdateValue();
    }
  }, [id]);

  //Fetch Data By ID
  const fetchUpdateValue = async () => {
    try {
      const res = await request(BASEURL, getProductcategory, {
        id: id,
      });
      const v = res.getProductcategory;

      setSelectedData(v);
      setCategoryData({
        categoryName: v.categoryName,

        categoryNameStatus: v.categoryName ? "success": "unchecked",
      });
    } catch (err) {
      console.error("Couldn't fetch data: ",err.message);
    }
  };

    //Create Mutation
    const handleAddCategoryData = async () => {
      setConfirmationDialog({
        open: true,
        title: "Confirmation",
        message: "Are you sure do you want to submit your details.",
        showCancel: true,
        showConfirm: true,
        onConfirm: async () => {
          try {
            const response = await request(BASEURL, AddCategoryMutation, {
              user: currentUser?.id,
              categoryName: categoryData.categoryName,
            });
            
            setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
            setSuccessStatus(true);
            setSucessTitle(" Catergory Created");
            setTimeout(() => {
              setSuccessStatus(false);
              navigate("/category");
            }, 1000);
          }
           catch (error) {
            console.error("Couldn't Create: ", error?.response.errors[0].message);
  
            setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
            setErrorStatus(true);
            setErrormessage(error?.response?.errors[0]?.message);
            setTimeout(() => {
              setErrorStatus(false);
            }, 1000);
          } finally {
            setCirleLoading(false);
          }
        },
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    };

    //Update Mutation
  const handleEditCategoryData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Edit your details.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        const values = {
          categoryName: categoryData.categoryName,
          categoryNameStatus: categoryData.categoryName ? "success" : "unchecked",
        };
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);
        const {errormessage,updateStatus} = await updateProductcategoryService(values, id);
        setCirleLoading(false);
        if (updateStatus) {
          setSuccessStatus(true);
          setSucessTitle("Category Updated");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/category");
          }, 1000);
        } else {
          setErrorStatus(true);
          setErrormessage(errormessage)
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Delete Function
  const handleDeleteCategory = () => {
      setConfirmationDialog({
        open: true,
        title: "Confirmation",
        message: "Are you sure do you want to Delete your detail.",
        showCancel: true,
        showConfirm: true,
  
        onConfirm: async () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
          setPendingLoading(true);
          const delteStatus = await delteProductcategoryService(id);
          if (delteStatus) {
            setSuccessStatus(true);
            setSucessTitle("Category Deleted");
            setTimeout(() => {
              setSuccessStatus(false);
              navigate("/category");
            }, 1000);
          } else {
            setErrorStatus(true);
            setTimeout(() => {
              setErrorStatus(false);
            }, 1000);
          }
        },
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
  };  

  //Submit Validation
  const checkAllFields = () => {
    let allowSubmit = false;
    if (categoryData.categoryNameStatus === "success") {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  //Discard Function
  const handleDiscardButton = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setCategoryData({
      categoryName: selectedData?.categoryName,
      categoryNameStatus: "success"
    });
  };

  //Cancel Function
  const handleCancelCategoryData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message:
        "The Entered Details will not be saved. Do you want to Cancel it?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        // const delteStatus = await deleteBrandService(id);
        // if (delteStatus) {
        navigate("/category");
        // } else if (!delteStatus) {
        // }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Handle Change
  const handleCategoryDataChange = (event) => {
      let categoryState = { ...categoryData };
      const changeAllowed = true;
      switch (event.target.name) {
        case "categoryName":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9\\s@#\\$%\\^&\\*\\(\\)_\\+\\-=\\[\\]\\{\\};:'\"`~,.<>\\/?!\\\\|]{2,25})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              categoryState[event.target.name + "Status"] = "success";
            } else {
              categoryState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      if (changeAllowed) {
        categoryState[event.target.name] = event.target.value;
      }
      setCategoryData(categoryState);
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          done={confirmationDialog.done}
          back={confirmationDialog.back}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {togglePage.view === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Category Details
                    </MaterialTypography>
                  </Stack>
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Loading button group"
                  >
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                    <MaterialButton
                      variant="gradient"
                      size="small"
                      color="dark"
                      onClick={handleDeleteCategory}
                      startIcon={<DeleteIcon />}
                    >
                      delete
                    </MaterialButton>
                  </ButtonGroup>
                </Stack>
              )  :togglePage.edit === true? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Edit Category Details
                    </MaterialTypography>
                  
                  </Stack>
                  <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                </Stack>
              )
              
              : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Add Category Details
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
           <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
                        <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
                        <MaterialTypography
                        sx={{color:'#460058',fontFamily:'Aptos'}}
                          component="label"
                          variant="body2"
                          fontWeight="700"
                        >
                          Category Information
                        </MaterialTypography>
                      </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Category Name<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="categoryName"
                  placeholder="Enter Category Name"
                  size="small"
                  value={categoryData.categoryName}
                  onChange={handleCategoryDataChange}
                  error={
                    categoryData.categoryNameStatus === "error" ? true : false
                  }
                  success={
                    categoryData.categoryNameStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {categoryData.categoryNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Category should be maximum 20 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </MaterialBox>
          <MaterialBox
            mt={3}
            display="flex"
            justifyContent="center"
            alignItems="center"
            paddingTop="20px"
          >
            {togglePage.edit === true ? (
              <>
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  onClick={handleDiscardButton}
                >
                  Discard
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 1 }}
                  variant="gradient"
                  color="dark"
                  size="small"
                  disabled={!checkAllFields()}
                  onClick={handleEditCategoryData}
                >
                  Submit
                </MaterialButton>
              </>
            ) : togglePage.view === false && togglePage.edit === false ? (
              <>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  size="small"
                  onClick={handleCancelCategoryData}
                >
                  Cancel
                </MaterialButton>
                  <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  size="small"
                  disabled={!checkAllFields()}
                  onClick={handleAddCategoryData}
                >
                  Submit
                </MaterialButton>
              </>
            ) : null}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
